import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Linkedin, Facebook } from 'lucide-react';
import { IMAGES } from '../constants/images';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const subsidySchemes = [
    { name: 'RIPS 2024', path: '/subsidies/rips-2024' },
    { name: 'PMEGP', path: '/subsidies/pmegp' },
    { name: 'VYUPY', path: '/subsidies/vyupy' },
    { name: 'MSME Policy 2024', path: '/subsidies/msme-policy-2024' },
    { name: 'View All Schemes', path: '/subsidies' },
  ];

  return (
    <footer data-testid="footer" className="bg-[#0f172a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <img
              src={IMAGES.logo}
              alt="Thesaurus of Finance"
              className="h-14 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              A trusted consultancy firm providing end-to-end solutions in Finance and Government Subsidies since 2014.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/tofin-in/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="p-2.5 bg-white/10 rounded-lg hover:bg-[#00bcd4] transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="https://www.facebook.com/tofin.in"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook"
                className="p-2.5 bg-white/10 rounded-lg hover:bg-[#00bcd4] transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Services', path: '/services' },
                { name: 'Leadership', path: '/leadership' },
                { name: 'Clients', path: '/clients' },
                { name: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-link-${link.name.toLowerCase().replace(' ', '-')}`}
                    className="footer-link text-slate-400 text-sm hover:text-[#00bcd4] inline-block"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Subsidy Schemes */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Subsidy Schemes</h4>
            <ul className="space-y-3">
              {subsidySchemes.map((scheme) => (
                <li key={scheme.path}>
                  <Link
                    to={scheme.path}
                    className="footer-link text-slate-400 text-sm hover:text-[#00bcd4] inline-block"
                  >
                    {scheme.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-6">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <MapPin size={20} className="text-[#00bcd4] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">
                  104, Villa De Sanya, Plot No E-161,<br />
                  Ramesh Marg, C Scheme,<br />
                  Jaipur, Rajasthan 302001
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={20} className="text-[#00bcd4] flex-shrink-0" />
                <a
                  href="tel:+917791093252"
                  data-testid="footer-phone"
                  className="text-slate-400 text-sm hover:text-[#00bcd4] transition-colors"
                >
                  +91-77910-93252
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={20} className="text-[#00bcd4] flex-shrink-0" />
                <a
                  href="mailto:info@tofin.in"
                  data-testid="footer-email"
                  className="text-slate-400 text-sm hover:text-[#00bcd4] transition-colors"
                >
                  info@tofin.in
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} Thesaurus of Finance. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm">
              Designed & Developed by{' '}
              <a 
                href="https://www.zenithmarketingindia.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-[#00bcd4] hover:text-white transition-colors"
              >
                Zenith Marketing India
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
